export default function ImportMappingResultDialogController(
  ssDialogService
) {
  const vm = this;
  vm.handleCloseDialogClick = handleCloseDialogClick;

  function handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.global.importMappingResultDialog);
  }
}

ImportMappingResultDialogController.$inject = [
  'ssDialogService'
];
